import settings from "./settings";
import {seoData} from "./data";

export const metaByRoute = {

  '/' : {
    keywords: seoData.keywords,
    canonical: settings.domain,
    title: 'MAJ Technology Software Development Company, IT, Solutions, Mobile App Development Company, Customized Software Development Company, SMS, Temperature, Environment, Data Center, Data Centre, Server Room, AKCP, EVOKO, Call, Email, Alert, Notification, Meeting Room, Board Meeting, Paperless, Visitor Management Software, VMS, File sharing and collaboration, AMC, Abudhabi | MAJ Technology Dubai UAE GCC  customised software development, custom software development company, customised software, custom software development agency, custom software development services company, software development custom software development, visitor management system, visitor management software, visitor management system for office, guest management software, visitor system, office visitor management system, guest registration software, visitor management system kiosk, visitor management kiosk systems, kiosk based visitor management system, visitor management system mobile app, data center monitoring, environmental monitoring system, server room environmental monitoring, data center environmental monitoring, meeting room solutions, meeting room manager, meeting room system, conference room booking system, conference room reservation system, meeting room reservation system, conference room system, meeting room conference system, boardroom solutions, conference hall booking system, best file sharing for small business, file sharing solutions for small business, file sharing software for business, best file sharing software for business\n',
    description: seoData.description,
    robots: 'index follow',
    // googleSiteVerification: '-IiUP11Q_MHPo-fb9cBQO861DS2x3Fx-OOAiw7CAKkw',
  },
  'aboutMeta' : {
    keywords: seoData.keywords,
    canonical: settings.domain+'/about',
    title: 'About Us - MAJ Technology',
    description: 'Learn more about MAJ Technology, a leading Technology and Software Solutions Provider in the UAE and GCC, specializing in customized software solutions.',
    robots: 'index follow',
  },
  '/services/web-application-development' : {
    title: 'Web Application Development Dubai UAE | MAJ Technology',
    keywords: seoData.keywords,
    canonical: settings.domain+'/services/web-application-development',
    description: 'As the technology advances and the programming landscape changes to accomodate the worlds growing technological needs, MAJ Technology constantly evaluates the latest trends in the development community. We improve ourselves to provide our clients the best possible development solutions.',
    robots: 'index follow',
  },
  '/services/mobile-development' : {
    title: 'Mobile Application Development Dubai UAE | MAJ Technology',
    keywords: seoData.keywords,
    canonical: settings.domain+'/services/mobile-development',
    description: 'Mobile application development is the process of creating software apps that run on mobile devices like smartphones and tablets. These apps are designed to provide seamless performance, engaging user experiences, and access to device features like cameras, GPS, and notifications. Developers typically build mobile apps',
    robots: 'index follow',
  },
  '/services/customized-software' : {
    title: 'Custom Software Development Dubai UAE | MAJ Technology',
    keywords: seoData.keywords,
    canonical: settings.domain+'/services/customized-software',
    description: `${seoData.description} Custom Software Development Dubai UAE customized-software`,
    robots: 'index follow',
  },
  '/services/erp-solutions' : {
    title: 'ERP Software Development Dubai UAE | MAJ Technology',
    keywords: seoData.keywords,
    canonical: settings.domain+'/services/erp-solutions',
    description: `${seoData.description} ERP Software Development Dubai UAE erp-solutions`,
    robots: 'index follow',
  },
  '/products/emr-clini-visita' : {
    title: 'EMR Electronic Medical Records | CliniVista | MAJ Technology',
    keywords: 'EMR Electronic Medical Records, CliniVista Clinic Vista,  EMR Software, EMR System, EMR Solutions, Electronic Medical Records Software, Electronic Medical Records System, Electronic Medical Records Solutions, EMR Software Dubai UAE, EMR System Dubai UAE, EMR Solutions Dubai UAE',
    canonical: settings.domain+'/products/emr-clini-visita',
    description: 'EMR Electronic Medical Record CliniVista clini-test-visita',
    robots: 'index follow',
  },
  '/contact' : {
    title: 'Contact | MAJ Technology',
    keywords: seoData.keywords,
    canonical: settings.domain+'/contact',
    description: `Contact at MAJ Technology ${seoData.description}`,
    robots: 'index follow',
  },
}
